// extracted by mini-css-extract-plugin
module.exports = {"page":"next-level-power_page__x_TBm"};